import React from 'react';
import forEach from 'lodash/forEach';
import lowerCase from 'lodash/lowerCase';
import camelCase from 'lodash/camelCase';
import startCase from 'lodash/startCase';
import uniqBy from 'lodash/uniqBy';
import store from '../../../store';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as dashboardActions from '../../../store/actions/dashboardActions';
import { MIN_TERM_SIZE } from '../../../store/reducers/dashboardReducer';
import RadioField from '../../../components/controls/Form/components/RadioField';
import DropdownField from '../../../components/controls/Form/components/DropdownField';
import CheckboxField from '../../../components/controls/Form/components/CheckboxField';
import FormGroup from '../../../components/controls/Form/components/FormGroup';
import { TextBadge } from '../../../components/controls/Typography/TextBody';
import Tooltip from 'rc-tooltip';
import { InputField } from '../../../components/controls/Form';

import './Sidebar.less';

//preparing the filter options data
const requestCardOptions = [
  { value: 'Expanded', label: 'Expanded' },
  { value: 'Collapsed', label: 'Collapsed' },
];
const sortDirectionOptions = [
  { value: 'Ascending', label: 'Ascending' },
  { value: 'Descending', label: 'Descending' },
];

const sortingOptions = [
  { value: 'LastName', title: 'Last Name' },
  { value: 'FirstName', title: 'First Name' },
  { value: 'requestedBy', title: 'Requested By' },
  { value: 'requestedOn', title: 'Requested On' },
  { value: 'Type', title: 'Type' },
];

/**
 * @typedef TStatusFilterItem
 * @type {{statusText:string,status:string,count:number,checked:boolean}}
 */

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      xsContentVisible: false,
      defaultSearchTerm: props.storeDashboard.viewParams.searchTerm,
    };
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
    this.handleChangeAssignement = this.handleChangeAssignement.bind(this);
  }
  /**
   *
   * @param {Map<string, number>=} statusCount
   * @returns {TStatusFilterItem[]}
   */
  getStatusList = statusCount => {
    //conversions to support the recieved data
    return Object.entries(statusCount ?? {})
      .filter(([key]) => key !== 'resciended')
      .map(([status, count]) => ({
        statusText: startCase(camelCase(status)),
        status,
        count,
        checked: count > 0 && this.props.storeDashboard.viewParams.filterByStatus?.includes(status),
      }));
  };

  /**
   * @param {?import('../../../store/reducers/dashboardReducer').TEvaluationRequest[]=} requestItems
   * @returns {Array<{ email:string, name:string, checked:boolean, }>}
   */
  getAssigneeList = (requestItems = []) => {
    return [
      // add default delegate (My Recommendations)
      {
        name: 'My Recommendations',
        email: 'self',
        checked: this.props.storeDashboard.viewParams.filterByEmail?.indexOf('self') !== -1,
      },
      // add delegates. make sure to remove duplicates
      ...uniqBy(
        (requestItems ?? [])
          // filter out requests that are not delegated
          .filter(request => request.delegated)
          // map to delegate object
          .map(request => ({
            name: `Assigned by ${request.evaluatorName}`,
            email: request.emailAddress,
            checked: this.props.storeDashboard.viewParams.filterByEmail?.indexOf(request.emailAddress) !== -1,
          })),
        x => x.email
      ),
    ];
  };

  /**
   * @param {?import('../../../store/reducers/dashboardReducer').TEvaluationRequest[]=} requestItems
   * @returns {boolean}
   */
  hasAnyExternalAssignments = (requestItems = []) => {
    return (requestItems ?? []).some(request => request.delegated);
  };

  handleChangeStatus(name, checkState, status) {
    const selectedCheckboxes = new Set(this.props.storeDashboard.viewParams.filterByStatus);
    if (checkState) {
      selectedCheckboxes.add(lowerCase(status));
    } else {
      selectedCheckboxes.delete(lowerCase(status));
    }
    store.dispatch(
      dashboardActions.filterDashboardData({
        filterByStatus: Array.from(selectedCheckboxes),
      })
    );
  }

  handleChangeAssignement(name, checkState, email) {
    const selectedCheckboxes = new Set(this.props.storeDashboard.viewParams.filterByEmail);
    if (checkState) {
      selectedCheckboxes.add(email);
    } else {
      selectedCheckboxes.delete(email);
    }
    store.dispatch(
      dashboardActions.filterDashboardData({
        filterByEmail: Array.from(selectedCheckboxes),
      })
    );
  }

  updateStatus(selectedFilter) {
    let statusOptions = this.state.statusOptions;
    forEach(statusOptions, option => {
      if (option.statusText === selectedFilter) {
        option.defaultValue = true;
      }
    });
    this.setState({
      statusOptions,
    });
  }

  //dispatching actions for each and every sidebar event
  handleClearAll() {
    store.dispatch(dashboardActions.clearFilters());
  }

  handleSortingField(name, optionValue) {
    this.setState({
      radioEvent: optionValue,
    });
    store.dispatch(
      dashboardActions.filterDashboardData({
        selectedSort: optionValue?.toString(),
      })
    );
  }

  handleSortingDirection(name, optionValue) {
    this.setState({
      sortEvent: optionValue,
    });
    store.dispatch(
      dashboardActions.filterDashboardData({
        sortDirection: optionValue,
      })
    );
  }

  handleExpandCollapse(name, optionValue) {
    store.dispatch(
      dashboardActions.filterDashboardData({
        allExpanded: optionValue === 'Expanded',
      })
    );
  }

  /**
   *
   * @param {string} name
   * @param {string} searchTerm
   */
  handleSearchTerm(name, searchTerm) {
    store.dispatch(
      dashboardActions.filterDashboardData({
        searchTerm: searchTerm
          .split(' ')
          .filter(w => w.length >= MIN_TERM_SIZE)
          .join(' '),
      })
    );
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      statusOptions: nextProps.statusList,
    });
  }

  componentWillMount() {
    this.setState({
      statusOptions: this.props.statusList,
    });
  }

  toggleSidebar() {
    this.setState({
      xsContentVisible: !this.state.xsContentVisible,
    });
  }

  render() {
    return (
      <div id="sidebar" className={`${this.props.classNames ?? ''}`}>
        <div className={`lsn-panel lsn-form-sidebar-panel`}>
          <div
            className={`toggle-header show-md ${this.state.xsContentVisible ? 'expanded' : 'collapsed'}`}
            onClick={() => this.toggleSidebar()}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === 'Space') {
                e.preventDefault();
                e.stopPropagation();
                this.toggleSidebar();
              }
            }}
            tabIndex={0}
          >
            <i className="far fa-bars pointer mr-2"></i>
            <strong>Filter and Sort Options</strong>
          </div>

          <FormGroup
            classNameWrapper={'lsn-search'}
            controlRender={params => (
              <InputField
                name={'search'}
                ariaLabel={'Search'}
                onChange={this.handleSearchTerm.bind(this)}
                title={'Search'}
                inputType="search"
                debounceOnChange={299}
                placeholder="Search by any keyword..."
                postControlSlot={
                  <small className="search-icon">
                    <i className="fas fa-search color-primary"></i>
                  </small>
                }
                defaultValue={this.state.defaultSearchTerm}
                alwaysDisplayErrorMessage
                customValidator={({ value, errorMessage }) => {
                  const isError = value.split(' ').some(term => term.length < MIN_TERM_SIZE);
                  return isError && value ? 'Please enter 3 chars for each search term.' : errorMessage;
                }}
                {...params}
              />
            )}
          />

          <FormGroup
            label={'View:'}
            classNameWrapper={'lsn-view'}
            controlRender={params => (
              <RadioField
                name={'view'}
                ariaLabel={'View'}
                selectedOptionValue={this.props.storeDashboard.viewParams.allExpanded ? 'Expanded' : 'Collapsed'}
                onChange={this.handleExpandCollapse.bind(this)}
                title={'View'}
                options={requestCardOptions}
                {...params}
              />
            )}
          />

          <FormGroup
            label={'Sort By:'}
            classNameWrapper={'lsn-sort-mode'}
            controlRender={params => (
              <>
                <DropdownField
                  title={'Sort By'}
                  name={'sortBy'}
                  options={sortingOptions}
                  selectedValue={this.props.storeDashboard.viewParams.selectedSort}
                  showDefault={false}
                  onChange={this.handleSortingField.bind(this)}
                />
                <div className="divider"></div>
                <RadioField
                  name={'sort'}
                  ariaLabel={'Sort by ' + this.props.selectedSort}
                  selectedOptionValue={this.props.storeDashboard.viewParams.sortDirection}
                  onChange={this.handleSortingDirection.bind(this)}
                  title={'Sort By ' + this.props.selectedSort}
                  options={sortDirectionOptions}
                  {...params}
                />
              </>
            )}
          />

          <FormGroup
            label={'Show:'}
            classNameWrapper={'lsn-filter-status'}
            controlRender={params => (
              <CheckboxField
                ariaLabel="Show Filter"
                options={this.getStatusList(this.props.storeDashboard.dashboardData?.statusCount).map(option => ({
                  value: option.status,
                  title: option.statusText,
                  checked: option.checked,
                  disabled: option.count === 0,
                  labelClassName: `lsn-filter-tag lsn-filter-tag-${option.status} ${
                    this.props.storeDashboard.filterByStatus?.includes(option.status) ? 'checked' : 'unchecked'
                  }`,
                  label: (
                    <>
                      {option.statusText}
                      {option.count > 0 ? (
                        <TextBadge className="ml-1" aria-label={`Has ${option.count} results.`}>
                          {option.count}
                        </TextBadge>
                      ) : null}
                    </>
                  ),
                }))}
                onChange={(name, checkState, status) => this.handleChangeStatus(name, checkState, status)}
                {...params}
              />
            )}
          />

          <FormGroup
            label={'Show:'}
            classNameWrapper={'lsn-filter-status'}
            hidden={!this.hasAnyExternalAssignments(this.props.storeDashboard.dashboardData?.recommendationRequest)}
            controlRender={params => (
              <CheckboxField
                ariaLabel="Show Filter"
                options={this.getAssigneeList(this.props.storeDashboard.dashboardData?.recommendationRequest).map(
                  option => ({
                    value: option.email,
                    title: option.name,
                    checked: option.checked,
                    label: (
                      <Tooltip
                        key={`rating.${option.email}.tooltip`}
                        showArrow
                        overlay={option.email === 'self' ? 'My Recommendations' : option.email}
                        placement="right"
                        overlayStyle={{ color: 'var(--main-black) !important' }}
                      >
                        <span>{option.name}</span>
                      </Tooltip>
                    ),
                  })
                )}
                onChange={(name, checkState, status) => this.handleChangeAssignement(name, checkState, status)}
                {...params}
              />
            )}
          />

          <a tabIndex={0} onKeyPress={this.handleClearAll.bind(this)} onClick={this.handleClearAll.bind(this)}>
            Reset Criteria
          </a>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    storeDashboard: state.dashboard,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(dashboardActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
